// RepoDetailDialog —— 仓库详情对话框(统一关闭约定,对齐 docs/ui_dialog)
// 由列表页点击行打开:Explore / Dashboard / AdminRepo 内联此对话框,
// 内嵌受控的 RepoDetailPage(经 props 传 owner/name),删除仓库后自动关闭。
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogContent,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { DatabaseRegular } from '@fluentui/react-icons';
import { DialogCloseTitle } from '@/components/DialogCloseTitle';
import { RepoDetailPage } from '@/pages/RepoDetailPage';

const useStyles = makeStyles({
  content: {
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  embed: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    paddingBottom: tokens.spacingVerticalL,
  },
});

export function RepoDetailDialog({
  owner,
  name,
  onClose,
}: {
  owner: string | null;
  name: string | null;
  onClose: () => void;
}) {
  const styles = useStyles();
  const open = !!owner && !!name;
  return (
    <Dialog open={open} onOpenChange={(_, d) => !d.open && onClose()} modalType="alert">
      <DialogSurface style={{ width: '95vw', maxWidth: 1280, height: '95vh' }}>
        <DialogBody style={{ height: '100%' }}>
          <DialogCloseTitle
            title={open ? `${owner}/${name}` : '仓库详情'}
            icon={<DatabaseRegular />}
            onClose={onClose}
          />
          <DialogContent className={styles.content}>
            {open && (
              <div className={styles.embed}>
                <RepoDetailPage owner={owner ?? ''} name={name ?? ''} />
              </div>
            )}
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}